import React from 'react';
import { Forms, Modal, SaveButton, SystemText } from 'e4shared';
import { useDispatch, useSelector } from 'react-redux';
import { apiGet, apiPatch } from 'services';
import { setShowSuccess } from 'actions/ui';

export const Groups = ({ show, close, users, groups }) => {
    const dispatch = useDispatch();

    const [ids, setIds] = React.useState([]);
    const [allUsers, setAllUsers] = React.useState('');
    const [saving, setSaving] = React.useState(false);
    const [error, setError] = React.useState(false);

    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        if (show?.length) {
            const selectedUsers = users
                .filter(x => (show || []).some(s => s === x.id))
                .sort((a, b) => (a.list_Name > b.list_Name ? 1 : -1))
                .map(x => x.full_Name);
            const joined = selectedUsers.join('<br />');
            setAllUsers(joined);
        }
    }, [show]);

    const closeMe = () => {
        setIds([]);
        setSaving(false);
        setError(false);
        close();
    };

    const save = () => {
        if (!ids.length) {
            setError(SystemText('Admin/User/Table/Options/Group/Error'));
            setSaving(false);
        } else {
            apiPatch('profile-groups-membership', { group_Ids: ids, profile_Ids: show }, user.guid, () => {
                dispatch(setShowSuccess(SystemText('Admin/User/Table/Options/Group/Success')));
                closeMe();
            });
        }
    };

    const footer = (
        <>
            <SaveButton className="btn btn-success" saving={saving} setSaving={setSaving} onClick={save}>
                {SystemText('General/Buttons/Save')}
            </SaveButton>
            <button className="btn" onClick={closeMe}>
                {SystemText('General/Buttons/Cancel')}
            </button>
        </>
    );

    return (
        <Modal show={show} close={closeMe} title={SystemText('Admin/User/Table/Options/Group/Title')} footer={footer}>
            <div className="bold-form">
                <Forms.Select
                    label={SystemText('Admin/User/Table/Options/Group/Groups')}
                    data={groups}
                    onChange={setIds}
                    error={error}
                    allowMultiple
                    mandatory
                />
                {allUsers && (
                    <Forms.Label label={SystemText('Admin/User/Table/Options/Group/Users', show.length)} value={allUsers} />
                )}
            </div>
        </Modal>
    );
};

export default Groups;
